import { useRef, useState } from 'react';
import { post } from '../../services/api';
import AdminSection from "../AdminSection/AdminSection";
import Select from 'react-select';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export default function GerenciamentoIndicesProjecao({ setNotifier }) {
    const [indicadorFiltro, setIndicadorFiltro] = useState(null);
    const [mesFiltro, setMesFiltro] = useState(null);
    const [disabledGerenciamentoIndices, setDisabledGerenciamentoIndices] = useState(true);
    const [indices, setIndices] = useState([]);
    const [isModalAlterarIndiceOpen, setIsModalAlterarIndiceOpen] = useState(false);
    const [indiceAlteracao, setIndiceAlteracao] = useState(null);
    const [salvarIndice, setSalvarIndice] = useState(null);
    const inputRef = useRef(null);

    const selectStyle = {
        control: (base, state) => ({
            ...base,
            background: "unset",
            borderColor: "#DCDCDC",
            borderRadius: "4px"
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 })
    }
    const nomeMeses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
        'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];

    //Options
    const optionsMes = Array.from(
        { length: 12 },
        (_, index) => ({ label: nomeMeses[index], value: index + 1 })
    )
    const currentYear = new Date().getFullYear();
    const optionsAno = Array.from(
        { length: 2 + currentYear - 2023 },
        (_, index) => ({ label: 2023 + index, value: 2023 + index })
    )

    const indicadores = [
        { value: 1, label: 'Mercantil' },
        { value: 2, label: 'Juros' },
        { value: 3, label: 'Serviços' },
        { value: 5, label: 'Inadimplência' },
    ];
    const optionsIndicadores = indicadores.map((indicador) => ({
        value: indicador.value,
        label: indicador.label,
    }));

    const [anoFiltro, setAnoFiltro] = useState({ label: currentYear, value: currentYear });

    async function getIndices(mes = null, ano = null, indicador = null) {
        try {
            if (indicador !== null && mes !== null && ano !== null) {

                const authToken = localStorage.getItem('adminToken');

                const requisicao = {
                    mes: mes.value,
                    ano: ano.value,
                    indicador: indicador.value
                }

                const response = await post('/admin/indicesprojecao', requisicao, authToken);

                setIndices(response);

                setDisabledGerenciamentoIndices(false);
            }
        } catch (error) {
            console.error('Erro ao busca índices:', error);
        }
    }

    const handleChangeIndicadorFiltro = (selectedOption) => {
        setIndicadorFiltro(selectedOption);
        getIndices(mesFiltro, anoFiltro, selectedOption)
    };

    const handleChangeMesFiltro = (selectedOption) => {
        setMesFiltro(selectedOption);
        getIndices(selectedOption, anoFiltro, indicadorFiltro)
    };

    const handleChangeAnoFiltro = (selectedOption) => {
        setAnoFiltro(selectedOption);
        getIndices(mesFiltro, selectedOption, indicadorFiltro)
    };

    function formatarData(data) {
        const date = new Date(data);

        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const ano = date.getFullYear();

        return `${dia}/${mes}/${ano}`;
    }

    const handleOpenModal = (item) => {
        setIndiceAlteracao(item);
        setSalvarIndice(item.indice);
        setIsModalAlterarIndiceOpen(true);
        document.body.classList.add('overflow-hidden');

        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current.focus();
            }
        }, 0);
    };

    const handleCloseModal = () => {
        document.body.classList.remove('overflow-hidden');
        setIsModalAlterarIndiceOpen(false);
    };

    async function alterarIndice() {
        try {
            const authToken = localStorage.getItem('adminToken');


            const requisicao = {
                dia: formatarData(indiceAlteracao.dia),
                indice: parseFloat(salvarIndice.replace(',', '.')),
                indicador: indicadorFiltro.value
            }
            const { response } = await post('/admin/alterarindicesprojecao', requisicao, authToken);

            if (response?.status >= 400) {
                setNotifier(false, response.data.Error)
            } else {
                setNotifier(true, 'Índice alterado com sucesso!');
                handleCloseModal();
                getIndices(mesFiltro, anoFiltro, indicadorFiltro);
            }

        } catch (error) {
            setNotifier(false, 'Erro ao alterar índice!');
            console.error('Erro ao alterar índice:', error);
        }
    }

    function formatarIndice(indice) {
        let indiceFormatado = indice;


        indiceFormatado = indiceFormatado.replace(/[^0-9,]/g, '');

        if (!indiceFormatado.startsWith('0')) {
            indiceFormatado = '0';
        }

        if (indiceFormatado.indexOf(',') > 1 || (indiceFormatado.indexOf(',') === -1 && indiceFormatado.length > 1)) {
            indiceFormatado = '0,' + indiceFormatado.slice(1).replace(/,/g, '');
        }

        if (indiceFormatado.includes(',')) {
            const [parteInteira, parteDecimal] = indiceFormatado.split(',');
            indiceFormatado = parteInteira + ',' + parteDecimal.slice(0, 8);
        }

        const valorNumerico = parseFloat(indiceFormatado.replace(',', '.'));
        if (valorNumerico > 1) {
            indiceFormatado = '1';
        }

        return indiceFormatado;
    }

    return <>
        <AdminSection
            etapa={1} titulo={'Selecione os filtros'}
        >
            <div className='admin-filtros-dividos p-8'>
                <div className='admin-filtros-left'>
                    <div>
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="indicador">Selecione o indicador</label>
                        <Select
                            name="indicador"
                            id="indicador"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={indicadorFiltro}
                            onChange={handleChangeIndicadorFiltro}
                            options={optionsIndicadores}
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Indicador"
                        />
                    </div>
                    <div >
                        <label style={{ whiteSpace: 'nowrap' }} htmlFor="mes">Selecione o período</label>
                        <Select
                            name="mes"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsMes}
                            value={mesFiltro}
                            onChange={handleChangeMesFiltro}
                            placeholder="Mês"
                            required
                            menuPortalTarget={document.body}
                            styles={selectStyle}
                            isSearchable={false}
                        />
                    </div>
                    <div>
                        <Select
                            name="ano"
                            className="react-select"
                            classNamePrefix="react-select"
                            options={optionsAno}
                            value={anoFiltro}
                            onChange={handleChangeAnoFiltro}
                            required
                            menuPortalTarget={document.body}
                            styles={selectStyle}
                            isSearchable={false}
                        />
                    </div>
                </div>
            </div>
        </AdminSection>
        <div className='relatorio-metas-second'>
            <div className='metas-consulta-wrapper'>
                <AdminSection
                    etapa={2} titulo={'Gerenciar Índices'} disabled={disabledGerenciamentoIndices}
                >

                    <div className="body">
                        {indices?.length > 0
                            &&
                            <table className="adm-table metas-animais">
                                <thead>
                                    <tr>
                                        <th className='text-center'>Dia</th>
                                        <th className='text-center'>Dia da Semana</th>
                                        <th className='text-center'>Indicador</th>
                                        <th className='text-center'>Índice</th>
                                        <th className='text-center'>Índice Acumulado</th>
                                        <th className="acao-column">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(indices) && indices.map(indice => (
                                        <tr key={indices.dia} className={`adm-table-row row-metas-animais`}>
                                            <td className='text-center'>{formatarData(indice.dia)}</td>
                                            <td className='text-center'>{indice.dia_semana}</td>
                                            <td className='text-center'>{indice.indicador}</td>
                                            <td className='text-center'>
                                                {parseFloat(indice.indice) % 1 === 0
                                                    ? parseInt(indice.indice, 10)
                                                    : indice.indice.replace('.', ',')}
                                            </td>
                                            <td className='text-center'>
                                                {parseFloat(indice.indice_acumulado) % 1 === 0
                                                    ? parseInt(indice.indice_acumulado, 10)
                                                    : indice.indice_acumulado.replace('.', ',')}
                                            </td>
                                            <td className="acao-column">
                                                <button className="manage-meta-btn" onClick={() => handleOpenModal(indice)}>Alterar Índice</button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        }

                        {
                            isModalAlterarIndiceOpen && (
                                <div className="fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-10 overflow-auto">
                                    <div className="bg-white rounded-lg w-96 relative">
                                        <header className="bg-red-c1 p-2">

                                            <button className="absolute top-2 right-2 text-white" onClick={() => handleCloseModal()}>
                                                &times;
                                            </button>
                                            <p className="text-md mt-2 text-white text-left">Alterar Índice</p>
                                        </header>

                                        <div className='p-2'>

                                            <div className="mt-4">
                                                <div className="overflow-x-auto">
                                                    <p><strong>Dia: </strong>{formatarData(indiceAlteracao.dia)}</p>
                                                    <p><strong>Indicador: </strong>{indiceAlteracao.indicador}</p>
                                                </div>
                                            </div>

                                            <div className="mt-4 mb-4">
                                                <input
                                                    style={{ maxWidth: '190px' }}
                                                    placeholder="Índice"
                                                    type="text"
                                                    ref={inputRef}
                                                    value={salvarIndice.replace('.', ',')}
                                                    onChange={(e) => {
                                                        const indiceFormatado = formatarIndice(e.currentTarget.value);
                                                        setSalvarIndice(indiceFormatado);
                                                    }}
                                                />
                                            </div>

                                            <div className="modal-gerencia-animal-footer" style={{ justifyContent: 'center', gap: '16px', paddingLeft: '0', paddingRight: '0' }}>
                                                <button className="animal-cancel-btn" onClick={handleCloseModal}>Cancelar</button>
                                                <button className="animal-save-btn" onClick={alterarIndice} type="submit">Salvar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        {indices?.length <= 0 && indicadorFiltro != null && mesFiltro != null && anoFiltro != null &&
                            <span className="no-data-found">
                                <WarningAmberIcon style={{ width: '50px', height: '50px', marginBottom: '5px' }} />
                                <span>Não foi encontrado nenhum índice com os filtros utilizados</span>
                            </span>
                        }
                    </div>
                </AdminSection>
            </div>
        </div>

    </>
}









